function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import "./mealcard-modal.scss";
import template from "./mealcard-modal.html";

export var MealcardModalComponent = {
  template: template,
  transclude: {
    mealcard: "?nestedMealCard" },

  bindings: {
    onClose: "&" },

  controller: /*#__PURE__*/function () {MealcardModalComponentController.$inject = ["LayoutService", "$scope", "$timeout", "$stateParams"];
    function MealcardModalComponentController(LayoutService, $scope, $timeout, $stateParams) {
      "ngInject";_classCallCheck(this, MealcardModalComponentController);
      this.LayoutService = LayoutService;
      console.log(this);
      this.$scope = $scope;
      this.$timeout = $timeout;
      this.animateOnShow = false;
      this.isWeekOffset = !!$stateParams.week;
    }

    // $onInit() {
    //   this.onExitMealcardModal = () => {
    //     this.$scope.$emit('closeMealcardModal', false);
    //   }
    // }
    _createClass(MealcardModalComponentController, [{ key: "$onChanges", value: function $onChanges()
      {} }, { key: "$postLink", value: function $postLink()

      {var _this = this;
        Promise.resolve().
        then(function () {
          var activeCard = angular.element('.swiper-slide-active');
          var coordMealTop = activeCard.offset().top - angular.element(window).scrollTop();
          var coordMealLeft = activeCard.offset().left;
          var activeCardBodyHeight = angular.element('.show-mealcard-modal .meal-card__body').height();
          var windowHeight = angular.element(window).height();
          angular.element('.show-mealcard-modal .meal-card__body').css('height', 'auto');
          _this.mealCardBodyHeight = angular.element('.show-mealcard-modal .meal-card__body').outerHeight() + 4;
          angular.element('.show-mealcard-modal .meal-card__body').css('height', activeCardBodyHeight);
          if (coordMealTop < windowHeight / 2.5) {
            angular.element('.show-mealcard-modal .mealcard-nested').css({
              top: coordMealTop,
              left: coordMealLeft });

          } else {
            angular.element('.show-mealcard-modal .mealcard-nested').css({
              top: coordMealTop,
              left: coordMealLeft });

            _this.$timeout(function () {
              angular.element('.show-mealcard-modal .mealcard-nested').css({
                top: coordMealTop / 2.5,
                left: coordMealLeft,
                transition: 'top 0.3s' });

            }, 300);
          }
        }).
        then(function () {
          _this.$timeout(function () {
            _this.animateOnShow = true;
            angular.element('.show-mealcard-modal .meal-card__body').height(_this.mealCardBodyHeight);
          }, 300);
        });
      } }, { key: "$onDestroy", value: function $onDestroy()

      {} }]);return MealcardModalComponentController;}() };